import React from "react";

import { Coordinates } from "custom-types/Coordinates";
import { Dispensary } from "custom-types/Dispensary";

import OpenStatus from "components/Dispensary/OpenStatus";

import { getLocalizedDistanceAnyDispensary } from "./utils/dispensary";

type DispensaryInformationProps = {
  countryCode: string;
  dispensary: Dispensary;
  userLocation?: Coordinates;
  children?: React.ReactNode;
};

export const DispensaryInformation: React.FC<DispensaryInformationProps> = ({
  children,
  countryCode,
  dispensary,
  userLocation,
}) => {
  const { full: localizedDistance } = getLocalizedDistanceAnyDispensary(
    countryCode,
    dispensary,
    userLocation
  );

  return (
    <div className="rounded bg-green-20 p-md pt-sm text-xs mt-xl">
      <div className="font-bold">{dispensary.name}</div>

      {children}

      <div>
        <OpenStatus className="inline-block" />
        {localizedDistance && (
          <>
            <span className="mr-md ml-sm">|</span>
            <span className="text-green font-bold">{localizedDistance}</span>
          </>
        )}
      </div>
    </div>
  );
};
